import { inject, Injectable } from '@angular/core';
import { User } from 'oidc-client';
import { environment } from '../../../environments/environment';
import { AuthorizeService } from './authorize.service';

interface AuthMessage {
  type: 'AUTH_DATA';
  user: User;
}

type ParentMessage = AuthMessage;

@Injectable({
  providedIn: 'root',
})
export class IframeAuthService {
  private authService = inject(AuthorizeService);
  private readonly allowedOrigins = environment.allowedOrigins;

  constructor() {
    this.setupMessageListener();
    this.notifyParentReady();
  }

  private setupMessageListener(): void {
    window.addEventListener('message', (event) => {
      // Verificar origen por seguridad
      if (!this.allowedOrigins.includes(event.origin)) {
        return;
      }

      this.handleParentMessage(event.data as ParentMessage);
    });
  }

  private notifyParentReady(): void {
    // Notificar al padre que el iframe está listo para recibir datos
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        {
          type: 'CHILD_READY',
        },
        '*'
      );
    }
  }

  private handleParentMessage(message: ParentMessage): void {
    switch (message.type) {
      case 'AUTH_DATA':
        this.handleAuthData(message);
        break;
      default:
    }
  }

  private handleAuthData(message: AuthMessage): void {
    this.authService.user = message.user;

    // Guardar token y datos del usuario en storage local del iframe
    if (message.user?.access_token) {
      localStorage.setItem('authToken', message.user.access_token);
    }

    if (message.user) {
      localStorage.setItem('userData', JSON.stringify(message.user));
    }
  }

  // Método para que los guards accedan al token
  getToken(): string | null {
    return localStorage.getItem('authToken');
  }

  getUserData(): any | null {
    const userData = localStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    return !!token; // Aquí puedes agregar validación de expiración
  }

  hasReceivedAuthData(): boolean {
    return (
      !!localStorage.getItem('authToken') && !!localStorage.getItem('userData')
    );
  }
}
